import { hide } from '@floating-ui/dom';
import { defineStore } from 'pinia';

export const useSnackbarStore = defineStore('snackbar', {
  state: () => ({
    message: '',
    type: '',
    visible: false,
  }),
  actions: {
    show(message, type = 'info', duration = 3000) {
      this.message = message;
      this.type = type;
      this.visible = true;

      setTimeout(() => {
        this.visible = false;
      }, duration);
    },
    hide() {
      this.visible = false;
    },
  },
});
